<div class="respondent-edit-list">
    <div class="head-template pr-0">
        <div class="row w-100">
            <div class="col-3">
                Appraisees
            </div>
            <div class="row col-9 p-l-15">
                Respondents
            </div>
            <div *ngIf="getIsWarning()" class="is-warning">
            </div>
        </div>
    </div>
    <div class="card">
        <div class="participation-search">
            <input class="engagement-search-input" (keyup)="search($event)" (search)="search($event)" />
        </div>
        <div class="card-body pl-0 pr-0 p-b-0">
            <div class="row appraisee-item" [class.not-min-respondents]="minRespondentAmount && minRespondentAmount > getMinRespondentsAmount(processParticipator)" *ngFor="let processParticipator of filtredProcessParticipators | paginate: { itemsPerPage: pageSize, currentPage: pageNumber }">
                <div class="col-3 p-l-20 appraisee-name-item font-weight-bold">
                    <span class="m-r-10 mb-1" *ngIf="processParticipator.appraisee" [class.appraisee-edit]="processParticipator.isEdit">
                        <span class="appraisee-name">
                            {{ getAppraiseeName(processParticipator.appraisee) }}
                        </span>
                        <span>&nbsp;</span>
                        <span [collapse]="!processParticipator.isEdit">
                            <i (click)="deleteAppraisee(processParticipator.processDurationAppraiseeId)" class="mdi mdi-close"></i>
                            <app-delete-appraisee  *ngIf="!isDeleteModalHidden"
                                [processDurationAppraiseeId]="processParticipator.processDurationAppraiseeId">
                            </app-delete-appraisee>
                        </span>
                    </span>
                </div>
                <div class="row col-9 pr-0">
                    <div class="respondents-list">
                        <span class="m-r-10 mb-1" [class.respondents-edit]="processParticipator.isEdit" *ngFor="let respondent of getProcessParticipator(processParticipator); let i = index">
                                <span class="respondent-name">
                                {{ respondent.name }}
                                <span class="tooltip-respondent">
                                    <span class="m-t-10 m-l-10 m-r-10 m-b-10">
                                        <span class="caption">
                                            Business Unit
                                        </span>
                                        <span class="data-list">
                                            {{ respondent.businessUnitDisplayName }}
                                        </span>
                                        <span class="caption">
                                            Grade
                                        </span>
                                        <span class="data-list">
                                            {{ respondent.grade }}
                                        </span>
                                        <span  class="caption"> 
                                            Criterions
                                        </span>
                                        <span class="data-list">
                                            <span *ngFor="let criterion of getRespondentCriterions(respondent)">
                                                {{ criterion }}
                                                <br>
                                            </span>
                                        </span>
                                        <span class="caption">
                                            Regarding
                                        </span>
                                        <span *ngIf="processParticipator.appraisee" class="data-list">
                                            {{ getRegardingGradeText(respondent.gradeLevel, processParticipator.appraisee.gradeLevel) }}
                                        </span>
                                    </span>
                                </span>
                            </span>
                            <span>&nbsp;</span>
                            <span [collapse]="!processParticipator.isEdit">
                                <i (click)="deleteRespondent(processParticipator.processDurationAppraiseeId, respondent.id)" class="mdi mdi-close"></i>
                                <app-delete-respondent  *ngIf="!isDeleteModalHidden"
                                [appraiseeId]="processParticipator.appraisee !== null ? processParticipator.appraisee.id : null" 
                                [processDurationAppraiseeId]="processParticipator.processDurationAppraiseeId" 
                                [respondentId]="respondent.id"
                                [allowSelfAssesment]="allowSelfAssesment">
                            </app-delete-respondent>
                            </span>
                        </span>
                        <i (click)="processParticipator.isEdit = !processParticipator.isEdit"
                           [class.ti-pencil]="!processParticipator.isEdit"
                           [class.ti-arrow-right]="processParticipator.isEdit">
                        </i>
                        <div class="m-t-10 m-b-10" [collapse]="!processParticipator.isEdit">
                            <span (click)="openAddRespondentModal(processParticipator)"  class="add-btn"></span>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="filtredProcessParticipators && filtredProcessParticipators.length > 0" class="text-center">
                <pagination-controls (pageChange)="changePageNumber($event)"></pagination-controls>
            </div>
        </div>
    </div>
</div>
<ng-template #deleteTemplate><i (click)="openModal(deleteRespondent)" class="mdi mdi-close"></i></ng-template>